export default "__VITE_ASSET__gjGANDiM__"